"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmbientValueInjector = void 0;
const utils_1 = require("@leavy/utils");
/**
 * Expose methods for injecting ambient values in invocation objects
 */
class AmbientValueInjector {
    constructor(resolver) {
        this.resolver = resolver;
    }
    /**
     * Inject the provided ambient values into the target invocation
     * @param {TCtx} context That must contains the ambient values to inject
     * @param {Class<T>} invocationClass
     * @param {Partial<T>} invocationData
     * @returns {T}
     */
    inject(context, invocationClass, invocationData) {
        if (!context.ambientValues) {
            throw new Error("The context argument must have ambient values defined");
        }
        const properties = utils_1.ObjectUtils.keys(context.ambientValues);
        for (let prop of properties) {
            const ambientValueClass = context.ambientValues[prop];
            const ambientValue = this.resolver.resolve(ambientValueClass);
            invocationData[prop] = ambientValue.get(context);
        }
        return invocationData;
    }
}
exports.AmbientValueInjector = AmbientValueInjector;
//# sourceMappingURL=AmbientValueInjector.js.map